import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { resolveZaggerLogoSrc } from '../utils/zaggerLogos';
import './ZaggerLogo.css';

/**
 * Theme-aware Zagger logo from /public/logos.
 * @param {{ variant?: 'full' | 'icon' | 'mark' | 'icon-duo', darkMode?: boolean, className?: string, alt?: string }} props
 */
function ZaggerLogo({
  variant = 'full',
  darkMode: darkModeProp,
  className = '',
  alt = 'Zagger',
}) {
  const { darkMode: authDarkMode } = useAuth();
  const darkMode = darkModeProp !== undefined ? darkModeProp : authDarkMode;
  const src = resolveZaggerLogoSrc(variant, { darkMode });

  return (
    <img
      src={src}
      alt={alt}
      className={`zagger-logo zagger-logo--${variant} ${className}`.trim()}
      decoding="async"
    />
  );
}

export default ZaggerLogo;
